import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { fontWeights, colors, breakpoints } from '@/styles'

const LabelText = styled.span`
  font-weight: ${fontWeights.medium};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey32};
  margin: 0;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin: 0 8px;
  }
`

const AnalyzingText = ({ isLocked }) => {
  const { t } = useTranslation()

  return (
    <LabelText isLocked={isLocked}>
      {t(
        'l.application.view.score_is_subjected_to_change.label',
        `* This score is subject to change as we're still analyzing this applicant's information. Please check back in 1-3 business days.`
      )}
    </LabelText>
  )
}

export default AnalyzingText
